/**
 * Автономная загрузка аватаров через IntersectionObserver.
 * Работает как для обычных страниц, так и для бесконечного скролла.
 * Полностью заменяет логику Gravatar на локальные аватары.
 */
document.addEventListener('DOMContentLoaded', function() {
    
    // Проверка поддержки IntersectionObserver
    if (!('IntersectionObserver' in window)) {
        // Fallback для старых браузеров: загружаем всё сразу
        const allAvatars = document.querySelectorAll('img[data-avatar-url]');
        allAvatars.forEach(img => {
            const url = img.getAttribute('data-avatar-url');
            if (url) img.setAttribute('src', url);
        });
        return;
    }

    /**
     * Загрузка конкретного аватара
     */
    const loadAvatar = (img) => {
        const avatarUrl = img.getAttribute('data-avatar-url');
        if (avatarUrl && img.getAttribute('src') !== avatarUrl) {
            img.setAttribute('src', avatarUrl);
            // Удаляем атрибут после загрузки, чтобы не обрабатывать повторно
            img.removeAttribute('data-avatar-url');
            img.classList.remove('load-avatar');
        }
    };

    /**
     * Создаем IntersectionObserver для ленивой загрузки аватаров
     */
    const avatarObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadAvatar(entry.target);
                // Прекращаем наблюдение после загрузки
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: '300px 0px', // Начинаем загрузку заранее (за 300px)
        threshold: 0.01
    });

    /**
     * Поиск и постановка аватаров на наблюдение
     */
    const observeAvatars = (container = document) => {
        const avatars = container.querySelectorAll('img[data-avatar-url]');
        avatars.forEach(img => avatarObserver.observe(img));
    };

    // 1. Инициализируем существующие аватары на странице
    observeAvatars();

    // 2. MutationObserver для динамически подгружаемого контента
    const contentContainer = document.querySelector('#main, .site-main, main');
    if (contentContainer) {
        const mutationObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === 1) { // Element node
                            observeAvatars(node);
                        }
                    });
                }
            }
        });
        mutationObserver.observe(contentContainer, { childList: true, subtree: true });
    }
});
